import React from 'react';

import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

import CardRaw from 'v3/components/Card';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import Tooltip from 'v3/components/Tooltip';
import { BadgeActive } from 'v3/components';

function Card({ client }) {
  return (
    <Col md={6}>
      <CardRaw
        header={
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
            <Tooltip content={<Text type="body">{client?.social_name}</Text>} placement="top">
              <Text
                className="d-inline-block"
                style={{ maxWidth: '240px' }}
                truncate
                transform="uppercase"
                color="dark"
                type="regular"
              >
                {client?.social_name}
              </Text>
            </Tooltip>
            {!client?.deleted_at ? (
              <BadgeActive pill light type="success" className="mr-2">
                <Text type="label">Ativo</Text>
              </BadgeActive>
            ) : (
              <BadgeActive pill light type="error" className="mr-2">
                <Text type="label">Inativo</Text>
              </BadgeActive>
            )}
          </div>
        }
        HeaderRightComponent={
          <div>
            <Link to={`/clientes/${client?.id}`}>
              <Button className="py-2">
                <Text color="white" type="regular" weight="500">
                  Detalhes
                </Text>
              </Button>
            </Link>
          </div>
        }
      >
        <Col className="mb-2 p-0">
          <Text color="dark" type="regular" weight="400">
            {client.cgccpf}
          </Text>
        </Col>
        <Col className="p-0">
          <Text color="gray" type="regular">
            {client?.email || 'Sem email informado'} <span className="ml-1 mr-1">|</span>{' '}
            {client?.phone || 'Sem telefone informado'}
          </Text>
        </Col>
      </CardRaw>
    </Col>
  );
}

export default Card;
